__turbopack_context__.v({
  "buttonWrapper": "OrganizationsList-module-scss-module__aSS-TW__buttonWrapper",
  "description": "OrganizationsList-module-scss-module__aSS-TW__description",
  "grid": "OrganizationsList-module-scss-module__aSS-TW__grid",
  "headerwrapper": "OrganizationsList-module-scss-module__aSS-TW__headerwrapper",
  "intervention": "OrganizationsList-module-scss-module__aSS-TW__intervention",
  "interventionSubtitle": "OrganizationsList-module-scss-module__aSS-TW__interventionSubtitle",
  "meta": "OrganizationsList-module-scss-module__aSS-TW__meta",
  "organization": "OrganizationsList-module-scss-module__aSS-TW__organization",
  "organizationWrapper": "OrganizationsList-module-scss-module__aSS-TW__organizationWrapper",
});
